import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { navigate } from "hookrouter";
import { Alert, setCookie, DecryptData, PostOptions } from "../../components/Config";
import axios from "axios";
import moment from 'moment';

function Declaration(props) {
  const [declare, setDeclare] = useState({ confirm: 0, extraconfirm: 0 });
  const [financials, setFinancials] = useState(props.financials);
  const [performance, setPerformance] = useState(props.performance);
  const [expenditures, setExpenditures] = useState(props.expenditures);
  const [shareholdings, setShareholdings] = useState(props.shareholdings);
  const [businessDetails, setBusinessDetails] = useState(props.businessDetails);
  const [registration, setRegistration] = useState(props.registration);
  const [ownerDetails, setOwnerDetails] = useState(props.ownerDetails);

  useEffect(() => {
    setFinancials(financials);
    setPerformance(props.performance);
    setShareholdings(props.shareholdings);
    setBusinessDetails(props.businessDetails);
    setRegistration(props.registration);
    setOwnerDetails(props.ownerDetails);
    setExpenditures(props.expenditures);
    // alert(JSON.stringify(financials.app_num));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (e.target.checked) {
      setFinancials((prevState) => ({
        ...prevState,
        [name]: 1,
      }));
    } else {
      setFinancials((prevState) => ({
        ...prevState,
        [name]: 0,
      }));
    }
  };

  const submitForm = (e) => {
    e.preventDefault();
    // alert('test')
    let year = parseInt(moment(businessDetails.date_commenced).format('YYYY'));
    let month = parseInt(moment(businessDetails.date_commenced).format('MM'));
    let age = moment().diff(ownerDetails.birth_date, 'years');
    
    //let hasexcludedExpenditure = false;
    let totalGHOwnership = 0;

  //   expenditures.map(row =>{
  //     if([10,11].includes(parseInt(row.item))){
  //      hasexcludedExpenditure = true;
  //     }
  //  })
    
    shareholdings.map(row =>{
        if(row.nationality == 1){
          totalGHOwnership += parseFloat(row.share);  
        }
    })

    if (financials.declaration !== 1 || financials.disclaimer !== 1) {
      Alert({
        title: "Declaration",
        message: "Please complete the Declaration to continue...",
        buttons: [{ label: "Ok" }],
      });
      return;
    }

    let queryData = {data: `SELECT * From owner WHERE app_num = '${financials.app_num}'`};
    axios(PostOptions("POST", queryData, "registration/squery"))
      .then((res) => {
        let ownerChk = DecryptData(res.data);
        
        if (ownerChk[0] === undefined) {
          Alert({
            title: "Owner",
            message: "Please go back and complete owner information",
            buttons: [{ label: "Ok" }],
          });
          return;
        }

        queryData = {data: `SELECT * From business WHERE app_num = '${financials.app_num}'`};
        axios(PostOptions("POST", queryData, "registration/squery"))
        .then((res) => {
          let businessChk = DecryptData(res.data);

          if (businessChk[0] === undefined) {
            Alert({
              title: "Business",
              message: "Please go back and complete business information",
              buttons: [{ label: "Ok" }],
            });
            return;
          }
              
          queryData = {data: `SELECT * From performance WHERE app_num = '${financials.app_num}'`};
          axios(PostOptions("POST", queryData, "registration/squery")).then((res) => {
            let performanceChk = DecryptData(res.data);

         
            let employeeSize = parseInt(businessDetails.emp_size_fulltime_male) + parseInt(businessDetails.emp_size_fulltime_female);
            let averageTurnOver = (parseFloat(performance.turnover2019) + parseFloat(performance.turnover2020) + parseFloat(performance.turnover2021) + parseFloat(performance.turnover2022))/4;
            let operationStatus = parseInt(businessDetails.operation_status);
            if(year <= 2022){
              if((averageTurnOver <= 21600000 && employeeSize >= 6 && employeeSize <= 100) || (averageTurnOver >= 180000 && averageTurnOver <= 21600000)){     
                    financials.status = 1;
                    
                    if(employeeSize >= 6 && employeeSize <= 30){
                      financials.enttype = 1;
                    }
                    if(averageTurnOver > 180000 && averageTurnOver <= 7200000){
                      financials.enttype = 1;
                    }
                    if(employeeSize >= 31 && employeeSize <= 100){
                      financials.enttype = 2;
                    }
                    if(averageTurnOver > 7200000 && averageTurnOver <= 21600000){
                      financials.enttype = 2;
                    }
                    
                    if(year == 2022){
                      if(month >= 1){
                        financials.status = -1;
                        financials.enttype = 0;
                      }
                    }else if(operationStatus == 2){
                      financials.status = -1;
                      financials.enttype = 0;
                    }else if(age < 18){
                      financials.status = -1;
                      financials.enttype = 0;
                    }
                    // else if(hasexcludedExpenditure){
                    //   financials.status = -1;
                    //   financials.enttype = 0; 
                    // }
                    else if(totalGHOwnership < 51){
                      financials.status = -1;
                      financials.enttype = 0; 
                    }

                  
              }else{
                financials.status = -1;
              }
            }else{
                financials.status = -1;
              }       
            props.handleChange(7, financials);
            
            axios(PostOptions("PUT", financials, `financing/${financials.id}`)).then((res) => {
                let resdata = DecryptData(res.data);
                //alert(JSON.stringify(resdata));
                if (resdata.id !== undefined) {
                  financials["id"] = resdata.id;
                  props.handleChange(7, financials);
                }
                  setCookie("appnum", financials.app_num);
                  if( financials.status != -1){
                  let msgData = {firstname: registration.firstname, mobile: registration.bus_phone, email: registration.bus_email, appnum: registration.app_num, status: financials.status};  
                  axios(PostOptions("POST", msgData, "business/sendmessage")).then((res) => {})
                  msgData = {firstname: registration.firstname, mobile: registration.bus_phone, email: registration.bus_email, appnum: registration.app_num, status: 3};
                  axios(PostOptions("POST", msgData, "business/sendmessage")).then((res) => {})
                  }
                  navigate("/completed", true);
                  window.location.reload();
                
            }).catch((error) => {
              Alert({ title: "Financials", message: error.message, buttons: [{ label: "Ok" }]});
            });
          })
        })
      })
                  
  };

  return (
    <div className="">
      <div className="pb-3">
        <b>
          I certify that my answers are true and complete to the best of my
          knowledge.
        </b>
      </div>
      <div className="pb-3">
        <b>
          I understand that any false or misleading information, documents or
          submissions in my application may result in criminal prosecution for
          fraud.
        </b>
      </div>
      <div className="pb-3">
        <b>
          I understand that by submitting this application I expressly give the
          Ghana Enterprises Agency (GEA) permission to:
        </b>
        <ul>
          <li>
            Request my financial records from the commercial banks and the
            Credit Reference Bureau.
          </li>
          <li>
            Validate and verify my identity documents with the specified issuing
            agency.
          </li>
          <li>
            Validate and verify my company registration details with the
            Registrar General’s Department of Ghana.
          </li>
          <li>
            Validate and verify my business and personal Tax Identification
            Number (TIN) with the Ghana Revenue Authority (GRA)
          </li>
          <li>
            Validate and verify my Environmental Permit with Environmental
            Protection Agency (EPA). Validate and verify my mobile money records
            with the operator of my mobile money account.
          </li>
          <li>Validate and verify my business and personal address.</li>
          <li>
            Contact me at any time during and after the processing of this
            application using the information I have submitted in this
            application.
          </li>
        </ul>
      </div>
      <div className="pb-3">
        <b>Should this grant application/request be approved, I agree:</b>
        <ul>
          <li>
            To apply any grant funding received expressly for the approved
            purpose{" "}
          </li>
          <li>
            To refund in full, and on demand, any grant funding received, if, my
            company/firm is found to have provided misleading information,
            whether deliberate or accidental, on this application.
          </li>
          <li>
            To provide, throughout the grant period, progress updates on the use
            of the grant funds and the delivery of the purpose of the grant to
            GEA in the manner and frequency as GEA may direct.
          </li>
        </ul>
      </div>
      <div className="pb-3">
        <b>Consent to data usage and sharing</b>
        <br /> I hereby give my consent that data associated with my application
        be collected for monitoring and evaluation purposes and that my data may
        be shared with evaluation partners (example, the World Bank research
        team).
      </div>
      <form id="frmDeclaration" method="POST" onSubmit={submitForm}>
        <div className="custom-control custom-checkbox">
          <div className="row">
            <div className="col-xs-12 col-md-1 mb-4">
              <input
                type="checkbox"
                className="form-control"
                value="1"
                style={{ height: "25px" }}
                name="declaration"
                id="defaultchecked"
                checked={financials.declaration}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-xs-12 col-md-11 mb-4">
              <label style={{ lineHeight: "25px" }} for="defaultchecked">
                <b>
                  I hereby declare that I understand the contents of this
                  document before submitting.
                </b>
                <span className="required">*</span>
              </label>
            </div>
            <div className="col-xs-12 col-md-1 mb-4">
              <input
                type="checkbox"
                className="form-control"
                value="1"
                style={{ height: "25px" }}
                name="disclaimer"
                id="defaultchecked2"
                checked={financials.disclaimer}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-xs-12 col-md-11 mb-4">
              <label style={{ lineHeight: "25px" }} for="defaultchecked2">
                <b>
                  I hereby declare that I have read over the contents of this
                  document to the Applicant and s(he) appears to understand same
                  before submitting.{" "}
                </b>
              </label>
            </div>
          </div>
        </div>
      </form>
      <div className="pb-3">
        <b>Attention</b>
        <br />
        You cannot come back to Edit this form when you submit it, however you
        can save and return later instead.
      </div>
      <button
        type="submit"
        form="frmDeclaration"
        className="btn btn-bg btn-outline text-white float-right pl-3 pr-3 pt-2 pb-2 mt-3"
        style={{ borderRadius: "20px" }}
      >
        <FontAwesomeIcon icon={faSave} size="lg" /> &nbsp; Submit Application
      </button>
    </div>
  );
}

export default Declaration;
